export default __webpack_public_path__ + "static/media/features.4.442cabb4.svg";